export default __webpack_public_path__ + "static/economy5-b8e49c13f8c8d3285a6590ef38f2070e.png";